import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../service/customer.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../shared/user.service';
import { DatePipe } from '@angular/common/';

@Component({
  selector: 'customers-not-reported',
  templateUrl: './customers-not-reported.component.html',
  styleUrls: ['./customers-not-reported.component.css']
})
export class CustomersNotReportedComponent implements OnInit {

  userDetails: any;
  resultTable: any[] = null;
  cols: any[];
  msgs: Message[] = [];
  accountManagers: any[];
  accountManagerSelected: any = null;

  constructor(private dataService: CustomerService, private router: Router, private userService: UserService, private datePipe: DatePipe) { }

  ngOnInit() {
    

    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails.Roles[0]) {
      }
      else {
        return this.showMessage('error', '', 'תקלה בקבלת הרשאות ');
      }
      this.dataService.getAccountManagersDDL().subscribe((result: any) => {
        this.accountManagers = result;
        if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length == 1) {
          this.accountManagerSelected = this.accountManagers[0].value;
        }
        //this.accountManagerChanged();
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
        });

    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת הרשאות ');
      });


    
    this.cols = [
      { field: 'IdentityNumber', header: 'ח.פ. מעסיק', invisible: false },
      { field: 'CustomerName', header: 'מעסיק', invisible: false },
      { field: 'MonthGap', header: 'עומק פיגור', invisible: false },
      { field: 'ContactName', header: 'שם איש קשר', invisible: false },
      { field: 'ContactEmail', header: 'דוא"ל איש קשר', invisible: false },
      { field: 'ContactPhone', header: 'טלפון איש קשר', invisible: false },
      { field: 'WorkersInMonth', header: 'מספר עובדים בחודש דיווח אחרון', invisible: false },
      { field: 'AccountManagerName', header: 'שם מנהל תיק', invisible: false },
      { field: 'MaxReportMonth', header: 'חודש דיווח אחרון', invisible: false },
      { field: 'MaxHodeshMaskoret', header: 'חודש שכר אחרון', invisible: false },
    ];

    this.getReport();
  }

  getReport(): void {
    
    this.dataService.getCustomersNotReported(this.accountManagerSelected).subscribe((result: any) => {
      this.resultTable = result;
      this.resultTable.forEach((item) => {
        item.MaxReportMonth = this.datePipe.transform(item.MaxReportMonth, 'MM/yyyy')
        item.MaxHodeshMaskoret = this.datePipe.transform(item.MaxHodeshMaskoret, 'MM/yyyy')
      });
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת דוח ');
    });
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customers-not-reported/customers-not-reported.component.ts